import React from 'react';
import { useEffect } from "react";
import './styles.css';
import Chart from 'react-apexcharts';
import { colors } from "../../../common/pallette/colors";
import { Box, Skeleton, Typography } from "@mui/material";

const StackedHorizontalBar = (props: {data: any, label?: string, colorPalette: any, width?: any}) => {

  const { data, label, colorPalette, width } = props;
  const optionsBar = {
    tooltip: {
      shared: false,
      followCursor: true,
    },
    chart: {
      stacked: true,
      stackType: "100%" as const,
      parentHeightOffset: 0,
      toolbar: {
        show: false
      },
      sparkline: {
        enabled: true
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        // columnWidth: '100%'
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number, opts: any) {
        const seriesIndex = opts.seriesIndex;
        const totalSeries = opts.w.config.series;

        if (totalSeries[seriesIndex].data[0] !== 0){
          return totalSeries[seriesIndex].data[0];
        } return '';
      },
      dropShadow: {
        enabled: false
      },
      offsetX: 0
    },
    stroke: {
      width: 0,
    },
    yaxis: {
      labels: {
        offsetX: 0,
        show: false
      }
    },
    xaxis: {
      categories: [label],
      labels: {
        show: false,
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    legend: {
      show: false
    },
    colors: colorPalette,
    states: {
      hover: {
        filter: {
          type: "none", 
          value: 0.2,
        },
      },
    }
  }

  // useEffect(() => {
  //   // setTimeout(() => {
  //     var chart = new ApexCharts(document.querySelector("#chart"), options);
  //     chart.render();
  //   // }, 3000)
  // }, [options]);  

  return(
    <Box sx={{ display: "flex" }}>
      <Typography className="mtbAuto mr5 fs13 fw800">{label}</Typography>
      {
        (data && data?.length > 0) ?
        <Box className="mtbAuto">
          <Chart
            options={optionsBar}
            height={42}
            series={data}
            type="bar"
            width={width || 400}
          />
        </Box>:
        <Box><Skeleton variant='rectangular' height={42} width={400} /></Box>
      }
    </Box>
  )
}

export default StackedHorizontalBar;